__turbopack_context__.v({
  "products": "style-module-scss-module__D5N_Ia__products",
  "products_list": "style-module-scss-module__D5N_Ia__products_list",
});
